import * as React from 'react';
import { MapPageFormFilter } from './Filters';
import { GlobalContext } from "../../../Contexts/GlobalContext";
import { Contract } from "tree-wallet-client";
import sortBy from 'lodash/sortBy';
import SearchableSelect from '../../../Component/SearchableSelect';

interface ContractFilterProps extends MapPageFormFilter {}

export default function ContractFilter(props: ContractFilterProps) {
  const { value: formValue, onChange: updateForm, isLoading } = props;
  const { contracts } = React.useContext(GlobalContext);
  const [value, setValue] = React.useState(null);
  const options = contracts && sortBy(contracts, ['description'])
    .map((contract: Contract) => {
      return { label: contract.description, value: contract.id }
    });

  return <SearchableSelect
    disabled={isLoading}
    placeholder='Select a contract'
    options={options}
    value={formValue || value}
    allowClear
    onChange={(value: any) => {
      setValue(value);
      updateForm && updateForm(value);
    }}
  />;
}